/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventTicket,
    JsonEventTicketFromJSON,
    JsonEventTicketFromJSONTyped,
    JsonEventTicketToJSON,
} from './JsonEventTicket';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventTicket
 */
export interface ApiResultOfListOfJsonEventTicket {
    /**
     * 
     * @type {Array<JsonEventTicket>}
     * @memberof ApiResultOfListOfJsonEventTicket
     */
    data?: Array<JsonEventTicket>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventTicket
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventTicket
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventTicket
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventTicket
     */
    result?: ApiResultOfListOfJsonEventTicketResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventTicketResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventTicketFromJSON(json: any): ApiResultOfListOfJsonEventTicket {
    return ApiResultOfListOfJsonEventTicketFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventTicketFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventTicket {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventTicketFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventTicketToJSON(value?: ApiResultOfListOfJsonEventTicket | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventTicketToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

